import { TFilters } from 'redux/types';
import { TShopifySalesChannelCatalogFilter } from 'redux/reducers/shopifyStores/types';

const FILTER_FIELD_NAME_MAP: Record<string, string> = {
	is_active: 'isActive',
	is_new: 'isNew',
	created_at: 'createdAt',
	updated_at: 'updatedAt',
	app_id: 'appId',
};

const BOOLEAN_FILTER_FIELDS = new Set(['is_active', 'is_new']);

export const mapCatalogFiltersForApi = (
	filters: TFilters,
): TShopifySalesChannelCatalogFilter[] =>
	filters.map(({ fieldName, value, operator }) => ({
		fieldName: FILTER_FIELD_NAME_MAP[fieldName] ?? fieldName,
		value: BOOLEAN_FILTER_FIELDS.has(fieldName) ? String(value) === 'true' : value,
		operator: operator ?? '=',
	}));
